module.exports = __webpack_public_path__ + "static/media/DSA Amp 1.77eee254.jpg";